import { put, call, takeLatest } from "redux-saga/effects";
import * as api from "./ChurchAPI";
import * as actionTypes from "../ActionTypes";
import { actionUpdateGlobalLoaderSagaAction } from "../GlobalLoader/GlobalLoaderAction";

function* readChurchesRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { apiPayloadRequest, callback } = action.payload || {};


    const response = yield call(api.readChurches, apiPayloadRequest);

    // Send data to reducer
    yield put({
      type: actionTypes.CHURCHES_READ_SUCCESS,
      payload: response,
    });

    // Run callback
    if (typeof callback === "function") {
      callback({
        type: 1,
        data: response?.data,
        totalRecords: response?.totalRecords,
      });
    }
  } catch (err) {
    const message = err?.response?.data?.errors?.[0]?.message || err?.message;


    yield put({
      type: actionTypes.CHURCHES_READ_FAIL,
      payload: message,
    });

    if (typeof action.payload?.callback === "function") {
      action.payload.callback({ type: 0, error: message });
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}
function* likeChurchRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { apiPayloadRequest, callback } = action.payload || {};


    const response = yield call(api.likeChurch, apiPayloadRequest);

    yield put({
      type: actionTypes.LIKE_CHURCH_SUCCESS,
      payload: response,
    });

    if (typeof callback === "function") {
      callback({
        type: 1,
        data: response?.data,
        message: response?.message,
      });
    }

  } catch (err) {
    const message = err?.response?.data?.errors?.[0]?.message || err?.message;


    yield put({
      type: actionTypes.LIKE_CHURCH_FAIL,
      payload: message,
    });

    if (typeof action.payload?.callback === "function") {
      action.payload.callback({ type: 0, error: message });
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* saveServiceVolunteerRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { apiPayloadRequest, callback } = action.payload || {};


    const response = yield call(api.saveServiceVolunteer, apiPayloadRequest);

    yield put({
      type: actionTypes.SAVE_SERVICE_VOLUNTEER_SUCCESS,
      payload: response,
    });

    if (typeof callback === "function") {
      callback({
        type: 1,
        data: response?.data,
        message: response?.message,
      });
    }
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.response?.data?.message ||
      err?.message;


    yield put({
      type: actionTypes.SAVE_SERVICE_VOLUNTEER_FAIL,
      payload: message,
    });

    if (typeof action.payload?.callback === "function") {
      action.payload.callback({ type: 0, error: message });
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* readFeaturedChurchesRequestSaga(action) {
  try {
    const { callback, ...apiPayload } = action.payload || {};


    const response = yield call(api.readFeaturedChurches, apiPayload);

    yield put({
      type: actionTypes.FEATURED_CHURCHES_READ_SUCCESS,
      payload: response,
    });

    if (typeof callback === "function") {
      callback({
        type: 1,
        data: response?.data,
        message: response?.message,
      });
    }
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.message ||
      err?.toString();

    yield put({
      type: actionTypes.FEATURED_CHURCHES_READ_FAIL,
      payload: message,
    });

    if (typeof action.payload?.callback === "function") {
      action.payload.callback({ type: 0, error: message });
    }
  }
}

function* readFavouriteChurchesRequestSaga(action) {
  try {
    const { apiPayloadRequest, callback } = action.payload || {};


    const response = yield call(api.readFavouriteChurches, apiPayloadRequest);

    yield put({
      type: actionTypes.FAVOURITE_CHURCHES_READ_SUCCESS,
      payload: response,
    });

    if (typeof callback === "function") {
      callback({
        type: 1,
        data: response?.data,
        message: response?.message,
      });
    }
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.message ||
      err?.toString();

    yield put({
      type: actionTypes.FAVOURITE_CHURCHES_READ_FAIL,
      payload: message,
    });

    if (typeof action.payload?.callback === "function") {
      action.payload.callback({ type: 0, error: message });
    }
  }
}

function* readHomeChurchesRequestSaga(action) {
  try {
    const { apiPayloadRequest, callback } = action.payload || {};


    const response = yield call(
      api.readHomeChurches,
      apiPayloadRequest
    );

    yield put({
      type: actionTypes.HOME_CHURCHES_READ_SUCCESS,
      payload: response,
    });

    if (typeof callback === "function") {
      callback({
        type: 1,
        data: response?.data,
        message: response?.message,
      });
    }
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.message ||
      err?.toString();

    yield put({
      type: actionTypes.HOME_CHURCHES_READ_FAIL,
      payload: message,
    });

    if (typeof action.payload?.callback === "function") {
      action.payload.callback({ type: 0, error: message });
    }
  }
}


function* readNearbyChurchesRequestSaga(action) {
  try {
    const { callback, ...apiPayload } = action.payload || {};


    const response = yield call(api.readNearbyChurches, apiPayload);

    yield put({
      type: actionTypes.NEARBY_CHURCHES_READ_SUCCESS,
      payload: response,
    });

    if (typeof callback === "function") {
      callback({
        type: 1,
        data: response?.data,
        message: response?.message,
      });
    }
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message ||
      err?.message ||
      err?.toString();


    yield put({
      type: actionTypes.NEARBY_CHURCHES_READ_FAIL,
      payload: message,
    });

    if (typeof action.payload?.callback === "function") {
      action.payload.callback({ type: 0, error: message });
    }
  }
}
function* unlikeChurchRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { apiPayloadRequest, callback } = action.payload || {};


    const response = yield call(api.unlikeChurch, apiPayloadRequest);

    yield put({
      type: actionTypes.UNLIKE_CHURCH_SUCCESS,
      payload: response,
    });

    if (typeof callback === "function") {
      callback({
        type: 1,
        data: response?.data,
        message: response?.message,
      });
    }
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message || err?.message;


    yield put({
      type: actionTypes.UNLIKE_CHURCH_FAIL,
      payload: message,
    });

    if (typeof action.payload?.callback === "function") {
      action.payload.callback({ type: 0, error: message });
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

export default function* ChurchWatcherSaga() {
  yield takeLatest(actionTypes.CHURCHES_READ_REQUEST, readChurchesRequestSaga);
  yield takeLatest(actionTypes.LIKE_CHURCH_REQUEST, likeChurchRequestSaga);
  yield takeLatest(
    actionTypes.SAVE_SERVICE_VOLUNTEER_REQUEST,
    saveServiceVolunteerRequestSaga
  );
  yield takeLatest(actionTypes.FEATURED_CHURCHES_READ_REQUEST, readFeaturedChurchesRequestSaga);
  yield takeLatest(actionTypes.FAVOURITE_CHURCHES_READ_REQUEST, readFavouriteChurchesRequestSaga);
  yield takeLatest(actionTypes.HOME_CHURCHES_READ_REQUEST, readHomeChurchesRequestSaga);
  yield takeLatest(actionTypes.NEARBY_CHURCHES_READ_REQUEST, readNearbyChurchesRequestSaga);
  yield takeLatest(actionTypes.UNLIKE_CHURCH_REQUEST, unlikeChurchRequestSaga);



}
